import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import profile from '../../imagenes/profile.jpg';

const Sidebar = ({ show }) => {
    const drawerClasses = show ? 'side-drawer open' : 'side-drawer';

    return (
      <nav 
        className={drawerClasses} 
        style={{background:'#343838', float:'left', position: "fixed"}}
        aria-label="Main navigation"
      >
          <div className="container-photo">
            <div className="separator"/>
            <div className="circular--landscape">
              <img 
                src={profile} 
                alt="Agustí Conesa profile" 
                className="photo-profile"
              />
            </div>
            <div className="separator"/>
          </div>
          <hr className="line"/>
          <div className="container-options">
            <ul className="options" role="menubar">
              <li className="option" role="menuitem">
                <Link to="/v1">HOME</Link>
              </li>
              <li className="option" role="menuitem">
                <Link to="/v1/about">ABOUT</Link>
              </li>
              <li className="option" role="menuitem">
                <Link to="/v1/resume">RESUME</Link>
              </li>
              <li className="option" role="menuitem">
                <Link to="/v1/portfolios">PORTFOLIOS</Link>
              </li>
              <li className="option" role="menuitem">
                <Link to="/v1/contact">CONTACT</Link>
              </li>
            </ul>
          </div>
      </nav>
    );
};

export default Sidebar;
